import { render, staticRenderFns } from "./PraiseDoctorList.vue?vue&type=template&id=1b97c717&scoped=true&"
import script from "./PraiseDoctorList.vue?vue&type=script&lang=js&"
export * from "./PraiseDoctorList.vue?vue&type=script&lang=js&"
import style0 from "./PraiseDoctorList.vue?vue&type=style&index=0&id=1b97c717&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97c717",
  null
  
)

export default component.exports